<template>
    <div id="privacyDetails">
        <div class="catalog">
            <div class="catalogTitle" @click="jumpTo('introduction')">导言</div>
            <div class="catalogTitle" @click="jumpTo('defined')">定义</div>
            <div class="catalogTitle" @click="jumpTo('catalog')">目录</div>
            <div class="catalogTitle" @click="jumpTo('mainBody')">正文</div>
            <div class="catalogText" @click="jumpTo('ref1')">
                一、本《隐私政策》的适用范围
            </div>
            <div class="catalogText" @click="jumpTo('ref2')">
                二、个人信息收集的范围与方式
            </div>
            <div class="catalogText" @click="jumpTo('ref3')">
                三、Cookie和同类技术的使用
            </div>
            <div class="catalogText" @click="jumpTo('ref4')">
                四、个人信息的存储
            </div>
            <div class="catalogText" @click="jumpTo('ref5')">
                五、个人信息的使用
            </div>
            <div class="catalogText" @click="jumpTo('ref6')">
                六、个人信息的共享、转让与公开披露
            </div>
            <div class="catalogText" @click="jumpTo('ref7')">
                七、个人信息的安全保护
            </div>
            <div class="catalogText" @click="jumpTo('ref8')">
                八、个人信息的管理
            </div>
            <div class="catalogText" @click="jumpTo('ref9')">
                九、未成年人使用条款
            </div>
            <div class="catalogText" @click="jumpTo('ref10')">
                十、隐私政策的变更
            </div>
            <div class="catalogText" @click="jumpTo('ref11')">
                十一、争议解决
            </div>
            <div class="catalogText" @click="jumpTo('ref12')">十二、其他</div>
        </div>
        <div class="content">
            <div class="contentTitle" ref="introduction" id="introduction">导言</div>
            <div class="contentText">
                深圳市羽拾科技有限公司（以下简称“羽拾”或“公司”）深知个人信息保护对您的重要性，并会尽我们最大努力保护您的个人信息安全，我们将依法采取安全保护措施，保护您的个人信息及隐私安全，并将恪守以下原则：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。
            </div>
            <div class="contentText">
                在您使用羽拾相关服务时，我们将按本《摩卡星用户隐私保护政策》（下称：《隐私政策》）收集、保存、使用、共享、披露及保护您的个人信息。我们希望通过本《隐私政策》向您介绍我们对您个人信息的处理方式。因此，我们提请您：<span
            >在使用羽拾相关服务、提交个人信息前，仔细阅读并透彻理解本《隐私政策》，在确认充分理解并同意后方使用相关产品和服务。如一旦您开始使用羽拾相关服务，则视为接受和认可本政策的全部内容。在我们更新本《隐私政策》后（我们会及时发布最新版本），如您继续使用羽拾相关服务，即意味着您完全理解本《隐私政策》（含更新版本）的全部内容，并同意我们按照本《隐私政策》收集、保存、使用、共享、披露及保护您的相关个人信息。</span
            >
            </div>
            <div class="contentTitle" ref="defined">定义</div>
            <div class="contentText">
                1.1、羽拾相关服务是指，羽拾及其关联方通过电子邮件、公众号、小程序、短信、电话等其他可行的方式一次或多次向您提供电子卡券资讯信息的推广及电子卡券产品的宣传、出售服务，电子卡券包括但不限于【优惠券、代金券、礼品卡等电子卡券】，具体以羽拾提供的二维图、条形码、兑换码、密码等组合形式体现。
            </div>
            <div class="contentText">
                1.2、关联方是指，因合作、投资或控制（或共同控制）关系而与羽拾产生任何联系的公司、组织或个人。
            </div>
            <div class="contentText">
                1.3、第三方是指，本《隐私政策》约定的您、羽拾及羽拾关联方范围以外的其他公司、组织或个人。
            </div>
            <div class="contentTitle" ref="catalog">目录</div>
            <div class="contentText">本隐私政策将帮助您了解以下内容：</div>
            <div class="contentText">
                一、本《隐私政策》的适用范围 <br/>
                二、个人信息收集的范围与方式<br/>
                三、Cookie和同类技术的使用 <br/>
                四、个人信息的存储 <br/>
                五、个人信息的使用<br/>
                六、个人信息的共享、转让与公开披露 <br/>
                七、个人信息的安全保护<br/>
                八、个人信息的管理 <br/>
                九、未成年人使用条款<br/>
                十、隐私政策的变更 <br/>
                十一、争议解决 <br/>
                十二、其他
            </div>
            <div class="contentTitle" ref="mainBody">正文</div>
            <div class="privacyTitle" ref="ref1">一、本《隐私政策》的适用范围</div>
            <div class="contentText">
                1.1
                、除本《隐私政策》另有规定外，本《隐私政策》所用词语与《用户服务协议》所定义的词语具有相同的涵义。
            </div>
            <div class="contentText">
                1.2
                、本《隐私政策》不适用于以下情况：通过羽拾相关服务进入或提供服务的第三方而向您收集的个人信息。该等第三方服务可能由相关第三方运营。您使用该等第三方服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非本《隐私政策》）约束，您需要仔细阅读其条款。请您妥善保护自己的个人信息，仅在必要的情况下向他人提供。本《隐私政策》仅适用于我们所收集、保存、使用、共享、披露信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。
            </div>
            <div class="privacyTitle" ref="ref2">二、个人信息收集的范围与方式</div>
            <div class="contentText">
                2.1、当您在使用羽拾相关服务时，您理解并同意，我们将可能收集、储存和使用下列与您个人信息有关的数据，如果您不提供相关信息，可能无法成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
            </div>
            <div class="contentText">
                2.2、您填写和/或提供的个人信息，包括：姓名、手机号码、电子邮箱、地址（非精确地址）以及与为您提供服务相关的问卷信息等能够单独或者与其他信息结合识别用户身份的信息。您可以选择不提供某一或某些信息，但是这样可能使您无法正常使用羽拾提供的服务。
            </div>
            <div class="contentText">
                2.3、日志信息：当您使用羽拾相关服务时，我们会自动收集您对我们服务的使用情况，作为有关网络日志保存。例如：您的搜索查询内容、IP地址、浏览信息、访问记录、点击信息、使用语言、访问服务的日期和时间、Cookie、Web
                Beacon等。
            </div>
            <div class="contentText">
                2.4、设备或应用信息：某些移动设备或应用包含唯一应用程序编号。例如您使用的移动设备、浏览器或其他程序所提供的配置信息、设备版本号、设备识别码等。为了向您提供更好的服务与改善您的服务体验，羽拾可能会记录硬件型号、操作系统版本号、国际移动设备识别码（IMEI）、网络设备硬件地址（MAC）等软硬件数据。
            </div>
            <div class="contentText">
                2.5、从第三方获得的您的信息：在获得您的同意后，我们可能从第三方获取您授权共享的账户信息，我们将会依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律法规规定的前提下，使用从第三方获得的您的个人信息。
            </div>
            <div class="contentText">
                2.6、当您使用相关搜索服务时，我们会收集您的搜索关键字信息、设备信息等。为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中。您理解并同意，如您的搜索关键字信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上的个人信息，因此我们有权以其他的目的对其进行使用；只有当您的搜索关键字信息可以单独或结合其他信息识别到您的个人身份时，则在结合使用期间，我们会将您的搜索关键字信息作为您的个人信息，与您的搜索历史记录一同按照本《隐私政策》对其进行处理与保护。
            </div>
            <div class="contentText">
                2.7、以上信息范围并非我们必然会收集的个人信息内容，我们会根据羽拾提供的服务内容选择收性集上述信息范围内与为您提供服务相关的必要信息。
            </div>
            <div class="privacyTitle" ref="ref3">三、Cookie和同类技术的使用</div>
            <div class="contentText">
                3.1、您理解并同意，当您使用羽拾相关服务时，为使您获得更好的访问体验，我们可能会使用各种技术来收集和存储信息，在此过程中可能会向您的计算机或移动设备上发送一个或多个Cookie或匿名标识符；Cookie或匿名标识符通常包含标识符、站点名称以及一些号码和字符。借助于
                Cookie技术，网站能够存储您的个人偏好、浏览记录等数据信息。
            </div>
            <div class="contentText">
                3.2、除
                Cookie以外，我们还可能会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击
                URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您个人偏好并改善我们的服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时向我们发送退订信息。
            </div>
            <div class="contentText">
                3.3、很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not
                Track 请求。但如果您的浏览器启用了 Do Not
                Track，那么我们会尊重您的选择。
            </div>
            <div class="contentText">
                3.4、当您使用羽拾相关服务时，我们可能会利用Cookie、网站信标和像素标签等其他同类技术收取您的信息用于了解您的偏好和使用习惯，进行数据分析，改善产品服务体验，提高广告效果，及时发现并防范安全风险，为您提供更好的服务。
            </div>
            <div class="contentText">
                3.5、我们不会将Cookie及相关同类技术用于本《隐私政策》所述目的之外的任何其他用途，您可以根据自己的偏好留存或删除Cookie，也可以清除您网页中保存的所有Cookie。
            </div>

            <div class="privacyTitle" ref="ref4">四、个人信息的存储</div>
            <div class="contentText">
                4.1、信息存储地点：我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。
            </div>
            <div class="contentText">
                4.2、存储期限：在您未向我们提出异议或发送删除通知的情况下，我们会安全有效的保存您的个人信息，仅在向您提供服务需要的情况下使用您的个人信息，但法律法规另有规定的除外。
            </div>
            <div class="privacyTitle" ref="ref5">五、个人信息的使用</div>
            <div class="contentText">
                5.1、为实现提供羽拾相关服务之目的，我们会根据本《隐私政策》的约定对所收集的您的个人信息进行使用。如有除此之外的任何其他用途，我们都会提前征得您的同意。具体而言，我们将为以下目的使用所收集的您的个人信息：
            </div>

            <div class="contentTextText">
                5.1.1、羽拾及其关联方主要向您一次或多次提供电子卡券资讯信息的推广及电子卡券产品的宣传、出售服务。
            </div>
            <div class="contentTextText">
                5.1.2、在我们提供相应服务所必需时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，努力确保我们向您提供的产品和服务的安全性。
            </div>
            <div class="contentTextText">
                5.1.3、对您的个人信息进行分析与处理，了解您的消费习惯与偏好，从而针对性地为您提供相关服务。
            </div>
            <div class="contentTextText">
                5.1.4、应羽拾后期业务需要及为了向您提供更好地服务，您授权羽拾将您的个人信息提供给羽拾关联方对您个人信息进行数据存储、分析和处理。
            </div>
            <div class="contentText">
                5.2、为了让您有更好的体验、享受我们的服务，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息数据，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关或可能感兴趣的信息。您在此授权我们将该服务所提供和储存的信息用于我们的其他服务。
            </div>
            <div class="contentText">
                5.3、在我们通过技术手段对您的个人信息进行去标识化处理后（为降低其他组织或个人通过去标识化处理后的个人信息识别到您的风险，我们会采取相应的管理措施，将去标识化后的数据与可用于恢复识别个人的信息分开存储，请您同意并知晓，在此情况下我们有权使用已经去标识化的信息,并在不透露您个人信息的前提下，我们有权对您相关去标识化的信息进行分析并予以商业化的利用（包括但不限于授权给羽拾关联方使用）。
            </div>
            <div class="contentText">
                5.4、请您注意，除非您向羽拾申请删除您的个人信息或撤回授权同意您在使用羽拾相关服务时所提供的所有个人信息，将在您使用羽拾相关服务期间持续授权我们在符合本《隐私政策》的范围内使用。
            </div>
            <div class="contentText">
                5.5、我们会对您对我们服务的使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的软件及相关服务的整体使用趋势。但这些统计信息不会包含您的任何个人信息。
            </div>
            <div class="privacyTitle" ref="ref6">
                六、个人信息的共享、转让与公开披露
            </div>
            <div class="contentText">
                6.1、我们会以高度的勤勉义务对待您的信息，我们会在取得您的同意或授权以后，与第三方共享您的个人信息，具体包括以下情形：
            </div>
            <div class="contentTextText">
                6.1.1、在获得您的同意或授权后，我们可能会将您的个人信息与我们的关联方共享，我们会根据对您提供服务的现实需要，且受本隐私政策中所声明目的的约束，将必要的个人信息共享给关联方，如因业务需要，确需超出前述授权范围使用个人信息的，将再次征求您的授权同意。
            </div>
            <div class="contentTextText">
                6.1.2、为实现本《隐私政策》中声明的相关目的，我们的某些服务将由第三方为您提供。为便于您享受该等服务，我们会根据合法、正当、必要、特定、目的明确的原则，与第三方共享您的某些必要的个人信息，第三方无权将共享的个人信息用于任何其他用途。
            </div>
            <div class="contentText">
                6.2、我们会对第三方的数据安全能力进行调查，与其签署相应的保密协定，并要求他们按照您同意的方式和目的、依据本《隐私政策》以及其他任何相关的保密和安全措施来处理您的个人信息。
            </div>
            <div class="contentText">
                6.3、随着我们业务的持续发展，我们将有可能进行兼并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。在发生前述变更时，我们将在转移您的个人信息前通知您有关情况，并按照法律法规及不低于本《隐私政策》所要求的安全标准继续保护或要求新的个人信息控制者继续保护您的个人信息。
            </div>
            <div class="contentText">
                6.4、未经您本人事先同意，我们不会向除公司及其关联方外的任何第三方，共享您的个人信息，但下列情形除外：
            </div>
            <div class="contentTextText">
                6.4.1、事先获得您的明确授权或同意；
            </div>
            <div class="contentTextText">6.4.2、您自行向第三方共享的；</div>
            <div class="contentTextText">
                6.4.3、与国家安全、国防安全、公共安全、公共卫生、公共利益直接相关的；
            </div>
            <div class="contentTextText">
                6.4.4、根据相关法律法规强制性要求所必须的情况下进行披露或提供，或与犯罪侦查、起诉、审判和判决执行等直接相关的。在符合法律法规的前提下，当我们收到前述披露信息的请求时，我们会要求对方必须出具与之相应的法律文件，如传票或调查函。我们将对所有的请求都进行审慎的审查，以确保其具备合法依据，且仅限于行政、司法部门因特定调查目的有合法权利获取的数据；
            </div>
            <div class="contentTextText">
                6.4.5、在法律法规允许的范围内，为维护羽拾其他用户、公司及其关联方的生命、财产等合法权益或维权产品或服务的安全所必需的，例如查找、预防、处理欺诈等违法活动和减少信用风险等；
            </div>
            <div class="contentTextText">
                6.4.6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
            </div>
            <div class="contentTextText">
                6.4.7、出于维护您或其他个人的生命、财产等中重大合法权益但又很难得到您本人同意的；
            </div>
            <div class="contentTextText">6.4.8、法律法规规定的其他情形。</div>
            <div class="contentText">
                6.5、我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
            </div>
            <div class="contentTextText">
                6.5.1、在获取您同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
            </div>
            <div class="contentTextText">
                6.5.2、在涉及兼并、收购或、重组、破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
            </div>
            <div class="contentText">
                6.6、我们仅会在以下情况下，公开披露您的个人信息：
            </div>
            <div class="contentTextText">6.6.1、获得您明确同意后；</div>
            <div class="contentTextText">
                6.6.2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
            </div>
            <div class="privacyTitle" ref="ref7">七、个人信息的安全保护</div>
            <div class="contentText">
                7.1、我们非常重视您个人信息的安全，将努力采取各种符合业界标准的合理安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或被未经授权的访问、公开披露、使用、修改、损坏、丢失或泄漏。
            </div>
            <div class="contentText">
                7.2、我们会使用加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用受信赖的保护机制防止您的个人信息遭到恶意攻击。
            </div>
            <div class="contentText">
                7.3、我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。
            </div>
            <div class="contentText">
                7.4、尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息绝对安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全。
            </div>
            <div class="contentText">
                7.5、我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止任何安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。
            </div>
            <div class="contentText">
                7.6、我们谨此特别提醒您，本《隐私政策》提供的个人信息保护措施仅适用于羽拾及关联方提供的服务。一旦您离开或下线，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护您在羽拾相关服务之外的应用、网站提交的任何个人信息，无论您登录或浏览上述软件、网站是否基于羽拾的链接或引导，我们对此不承担任何法律责任。
            </div>
            <div class="privacyTitle" ref="ref8">八、个人信息的管理</div>
            <div class="contentText">
                8.1、我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的访问、修改（更新或更正）、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。
            </div>
            <div class="contentText">
                8.2、您如需访问、修改（更新或更正）、删除以及撤回您提供给我们的个人信息，您可通过我们提供的服务邮箱【service@houselai.com】与我们取得联系，向我们提出有关申请，我们会根据您的需求为您提供访问、修改、删除及撤回服务。
            </div>
            <div class="contentText">
                8.3、在以下情形发生时，您可以向我们提出删除个人信息的请求：
            </div>
            <div class="contentTextText">
                8.3.1、如果我们处理个人信息的行为违反法律法规；
            </div>
            <div class="contentTextText">
                8.3.2、如果我们处理个人信息的行为违反了与您的约定；
            </div>
            <div class="contentTextText">
                8.3.3、如果您确定不再使用我们的产品或服务；
            </div>
            <div class="contentTextText">8.3.4、如果我们不再为您提供产品或服务。</div>
            <div class="contentText">
                若我们决定回应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
            </div>
            <div class="contentText">
                8.4、我们为您提供的服务需要基本的个人信息才能得以完成，对于可能额外收集的个人信息，您可以随时根据第8.2条的约定给予或收回您的授权同意。当您收回同意后，我们将不再处理您的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。如果您不想接受我们给您发送的商业广告，您随时可通过向我们的服务邮箱【service@houselai.com】发送反馈邮件与我们联系，在和您确认以后，我们不会再向您发送任何商业广告，除非再次取得您授权同意。
            </div>
            <div class="contentText">
                8.5、在您使用羽拾相关服务过程中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。
            </div>
            <div class="contentText">
                8.6、对于您上述合理的请求，我们原则上不会收取任何费用。但对多次重复、超出合理限度的请求，我们将视实际情况收取一定成本费用。对于无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
            </div>
            <div class="contentText">
                8.7、您的信息有以下情形之一时，按照法律法规要求，我们可能无法响应您的请求：
            </div>
            <div class="contentTextText">8.7.1、与国家安全、国防安全有关的；</div>
            <div class="contentTextText">
                8.7.2、与公共安全、公共卫生、重大公共利益等有关的；
            </div>
            <div class="contentTextText">
                8.7.3、与犯罪侦查、起诉、审判和执行判决等有关的；
            </div>
            <div class="contentTextText">
                8.7.4、有充分证据表明您存在主观恶意或滥用权利的；
            </div>
            <div class="contentTextText">
                8.7.5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
            </div>
            <div class="contentTextText">8.7.6、涉及商业秘密的；</div>
            <div class="contentTextText">8.7.7、其他法律法规规定的情形。</div>
            <div class="privacyTitle" ref="ref9">九、未成年人使用条款</div>
            <div class="contentText">
                9.1、若您是未满18周岁的未成年人，在使用羽拾相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本《隐私政策》。公司根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护儿童所必要的情况下收集、使用或公开披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
            </div>
            <div class="privacyTitle" ref="ref10">十、隐私政策的变更</div>
            <div class="contentText">
                10.1、为了给您提供更好的服务，羽拾相关服务将不时更新与变化，我们会适时对本《隐私政策》进行修订，该等修订构成本《隐私政策》的一部分并具有等同于本《隐私政策》的效力。但未经您同意，我们不会削减您依据当前生效的本《隐私政策》所应享受的权利。
            </div>
            <div class="contentText">
                10.2、本《隐私政策》更新后，我们会通过公告或其他适当的方式，说明隐私政策的具体变更内容并提醒您更新的内容，以便您及时了解本《隐私政策》的最新版本。
            </div>
            <div class="contentText">
                10.3、对于重大变更，我们还会提供更为显著的通知，我们会通过包括但不限于邮件、短信、私信或在浏览页面做特别提示等方式，说明《隐私政策》的具体变更内容。
            </div>
            <div class="contentText">
                10.4、本《隐私政策》所指的重大变更包括但不限于：
            </div>
            <div class="contentTextText">
                10.4.1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；
            </div>
            <div class="contentTextText">
                10.4.2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
            </div>
            <div class="contentTextText">
                10.4.3、个人信息共享、转让或公开披露的主要对象发生变化；
            </div>
            <div class="contentTextText">
                10.4.4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
            </div>
            <div class="contentTextText">
                10.4.5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
            </div>
            <div class="contentTextText">
                10.4.6、个人信息安全影响评估报告表明存在高风险时。
            </div>
            <div class="privacyTitle" ref="ref11">十一、争议解决</div>
            <div class="contentText">
                11.1、本《隐私政策》的解释及争议解决均应适用中华人民共和国大陆地区法律。当您因为本《隐私政策》的实施与我们产生任何纠纷时，双方应首先协商友好解决；若不能协商解决，您同意依照《服务协议》的约定将争议提交至深圳市南山区人民法院诉讼解决。
            </div>
            <div class="privacyTitle" ref="ref12">十二、其他</div>
            <div class="contentText">
                12.1、本《隐私政策》的标题仅为方便及阅读而设，并不影响本《隐私政策》中任何规定的含义或解释。
            </div>
            <div class="contentText">
                12.2、如果您对本《隐私政策》或其中有关您个人信息的收集、保存、使用、共享、披露、保护等功能存在意见或建议时，您可以通过羽拾反馈渠道反馈意见或投诉。我们会在收到您的意见及建议后尽快向您反馈。
            </div>
            <div class="contentText">
                12.3、我们设立了个人信息保护的专门反馈渠道，您可以通过以下方式联系我们：服务邮箱【service@houselai.com】
            </div>
            <div class="contentText">
                12.4、本《隐私政策》的版权为羽拾所有，在法律允许的范围内，公司保留最终解释和修改的权利。
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            jumpTo(id) {
                let height = this.$refs[id].offsetTop;
                // let clientHeight = document.documentElement.clientHeight;
                window.scrollTo({
                    top: height - 60,
                    behavior: "smooth"
                });
            }
        }
    };
</script>
<style lang="scss" scoped>
    #privacyDetails {
        display: flex;
        padding: 55px 0px;
        width: 1200px;
        margin: 0 auto;
        justify-content: space-between;

        .catalog {
            font-size: 16px;
            color: #1e2b4d;

            .catalogTitle {
                cursor: pointer;
                font-size: 24px;
                margin-bottom: 24px;

                &:last-child {
                    margin-bottom: 12px;
                }
            }

            .catalogText {
                cursor: pointer;
                margin-bottom: 12px;
            }
        }

        .content {
            width: 900px;

            .contentTitle {
                font-size: 30px;
                color: #152346;
                text-align: justify;
                margin-top: 64px;
                margin-bottom: 12px;

                &:first-child {
                    margin-top: 0px;
                }
            }

            .contentText {
                font-size: 16px;
                color: rgba($color: #152346, $alpha: 0.8);
                text-align: justify;
                line-height: 28px;
                margin-bottom: 8px;

                span {
                    color: #152346;
                    font-weight: 600;
                }
            }

            .contentTextText {
                margin-left: 40px;
                font-size: 16px;
                color: rgba($color: #152346, $alpha: 0.8);
                text-align: justify;
                line-height: 28px;
                margin-bottom: 8px;
            }

            .privacyTitle {
                font-size: 20px;
                color: #152346;
                text-align: justify;
                margin: 30px 0 12px;
            }
        }
    }
</style>
